import $ from 'jquery';
import Cookies from 'js-cookie';
require('normalize.css/normalize.css');
require('../css/main.scss');
import 'regenerator-runtime/runtime';
import { db, getDoc, doc, auth, registerUser, getCompanyByName, createCompany, serverTimestamp, onAuthStateChanged, signOutUser, addDoc, collection, updateDoc, setDoc, query, where, getDocs, orderBy, limit, onSnapshot, writeBatch, httpsCallable, functions } from '../js/firebaseConfig';
import { checkAuthAndRedirect } from '../js/redirect.js';
// import { startTokenRefreshManager, stopTokenRefreshManager } from '../js/authManager.js';

// ==========================================
// FIREBASE INDEX AUTO-OPENER
// Détecte automatiquement les erreurs d'index Firebase manquants
// et ouvre le lien de création dans un nouvel onglet
// ==========================================

(function() {
  if (window.__FIREBASE_INDEX_AUTO_OPENER__) {
    return;
  }
  window.__FIREBASE_INDEX_AUTO_OPENER__ = {
    openedUrls: new Set()
  };
  // Fonction pour extraire l'URL de création d'index depuis le message d'erreur
  function extractIndexUrl(errorMessage) {
    const urlMatch = errorMessage.match(/https:\/\/console\.firebase\.google\.com\/[^\s]+/);
    return urlMatch ? urlMatch[0] : null;
  }

  // Fonction pour afficher une notification toast
  function showIndexNotification(url) {
    const toast = $(`
      <div class="firebase-index-toast" style="
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #ff5722;
        color: white;
        padding: 16px 24px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 99999;
        max-width: 400px;
        animation: slideIn 0.3s ease-out;
      ">
        <div style="display: flex; align-items: start; gap: 12px;">
          <div style="font-size: 24px;">🔍</div>
          <div style="flex: 1;">
            <strong style="display: block; margin-bottom: 4px;">Index Firebase manquant détecté !</strong>
            <p style="margin: 0; font-size: 14px; opacity: 0.9;">
              Un nouvel onglet va s'ouvrir pour créer l'index automatiquement.
            </p>
          </div>
          <button class="close-toast" style="
            background: none;
            border: none;
            color: white;
            font-size: 20px;
            cursor: pointer;
            padding: 0;
            margin-left: 8px;
          ">×</button>
        </div>
      </div>
      <style>
        @keyframes slideIn {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        #webpack-dev-server-client-overlay, .webpack-dev-server-client-overlay { display: none !important; }
      </style>
    `);
    
    $('body').append(toast);
    
    // Fermer le toast au clic sur le bouton
    toast.find('.close-toast').on('click', function() {
      toast.fadeOut(200, function() {
        $(this).remove();
      });
    });
    
    // Auto-fermeture après 8 secondes
    setTimeout(() => {
      if (toast.length) {
        toast.fadeOut(200, function() {
          $(this).remove();
        });
      }
    }, 8000);
  }

  // Fonction pour gérer l'ouverture du lien d'index
  function handleIndexError(errorMessage) {
    const indexUrl = extractIndexUrl(errorMessage);
    
    if (indexUrl) {
      if (window.__FIREBASE_INDEX_AUTO_OPENER__.openedUrls.has(indexUrl)) {
        return true;
      }
      window.__FIREBASE_INDEX_AUTO_OPENER__.openedUrls.add(indexUrl);
      console.log('🔗 [Firebase Index Auto-Opener] URL d\'index détectée:', indexUrl);
      
      // Afficher la notification
      showIndexNotification(indexUrl);
      
      // Ouvrir le lien dans un nouvel onglet
      window.open(indexUrl, '_blank');
      
      return true;
    }
    
    return false;
  }

  // Intercepter console.error
  const originalConsoleError = console.error;
  console.error = function(...args) {
    // Appeler la fonction originale
    originalConsoleError.apply(console, args);
    
    // Vérifier si c'est une erreur d'index Firebase
    const errorString = args.map(arg => {
      if (typeof arg === 'string') return arg;
      if (arg && typeof arg === 'object' && arg.message) return arg.message;
      if (arg && typeof arg === 'object' && arg.toString) return arg.toString();
      return '';
    }).join(' ');
    
    if (errorString.includes('The query requires an index') && 
        errorString.includes('console.firebase.google.com')) {
      handleIndexError(errorString);
    }
  };

  // Intercepter les erreurs non capturées
  window.addEventListener('error', function(event) {
    const errorMessage = event.message || event.error?.message || '';
    
    if (errorMessage.includes('The query requires an index') && 
        errorMessage.includes('console.firebase.google.com')) {
      handleIndexError(errorMessage);
      event.preventDefault();
    }
  });

  // Intercepter les rejets de promesses non capturés
  window.addEventListener('unhandledrejection', function(event) {
    const errorMessage = event.reason?.message || event.reason?.toString() || '';
    
    if (errorMessage.includes('The query requires an index') && 
        errorMessage.includes('console.firebase.google.com')) {
      handleIndexError(errorMessage);
      
      // Ne pas afficher l'erreur dans la console (déjà géré)
      event.preventDefault();
    }
  });
})();

// ==========================================
// GESTION D'ERREURS GLOBALE - Protection contre les scripts bloqués
// ==========================================
(function() {
  // Intercepter les erreurs de scripts bloqués
  window.addEventListener('error', function(event) {
    // Ignorer les erreurs de scripts HubSpot bloqués
    if (event.filename && (
      event.filename.includes('hs-scripts.com') ||
      event.filename.includes('hs-analytics.net') ||
      event.filename.includes('hsforms.com') ||
      event.message.includes('ERR_BLOCKED_BY_CLIENT')
    )) {
      console.warn('⚠️ Script externe bloqué:', event.filename || event.message);
      event.preventDefault();
      return false;
    }
  });

  // Intercepter les erreurs de réseau
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && (
      event.reason.message && event.reason.message.includes('ERR_BLOCKED_BY_CLIENT')
    )) {
      console.warn('⚠️ Requête réseau bloquée:', event.reason);
      event.preventDefault();
      return false;
    }
  });
})();

// ==========================================
// GESTION DES ONGLETS - Nettoyage des listeners
// ==========================================
(function() {
  let authUnsubscribe = null;
  let notificationsUnsubscribe = null;
  
  // Nettoyer les listeners quand l'onglet devient inactif
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      
      // Nettoyer les listeners d'auth
      if (authUnsubscribe) {
        authUnsubscribe();
        authUnsubscribe = null;
      }
      
      // Nettoyer les listeners de notifications (vraie référence)
      if (window.__SR__notificationsUnsubscribe) {
        window.__SR__notificationsUnsubscribe();
        window.__SR__notificationsUnsubscribe = null;
        window.__SR__notificationsActiveForCompany = null;
      }
    } else {
      
      // Réinitialiser les listeners après un délai
      setTimeout(() => {
        if (typeof initNotificationsSystem === 'function') {
          initNotificationsSystem();
        }
      }, 1000);
    }
  });
  
  // Nettoyer avant de quitter la page
  window.addEventListener('beforeunload', function() {
    if (authUnsubscribe) authUnsubscribe();
    if (window.__SR__notificationsUnsubscribe) {
      window.__SR__notificationsUnsubscribe();
    }
  });
})();

// ==========================================

function cleanPhoneNumber(phone) {
    phone = (phone === undefined || phone === null) ? '' : phone.toString();
    // Nettoyage de base
    let cleaned = phone.replace(/'/g, '').replace(/\s/g, '');
    // Format international français : +33 X XX XX XX XX
    const match = cleaned.match(/^(\+\d{2})(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/);
    if (match) {
        // +33 1 23 45 67 89
        return `${match[1]} ${match[2]} ${match[3]} ${match[4]} ${match[5]} ${match[6]}`;
    }
    // Si ce n'est pas un numéro FR international, on tente de regrouper par 2 après l'indicatif
    const genericMatch = cleaned.match(/^(\+\d{2,3})(\d{6,})$/);
    if (genericMatch) {
        let indicatif = genericMatch[1];
        let reste = genericMatch[2].replace(/(\d{2})/g, '$1 ').trim();
        return `${indicatif} ${reste}`;
    }
    return cleaned;
}
window.cleanPhoneNumber = cleanPhoneNumber;

$(document).ready(function() {
  /**********
   * 
   * 
   * 
   * 
   * DEMO ASSESSMENT 
   * 
   * 
   * 
   * 
   * **********/
  $('.trophy').on('click', function() {
    var $trophy = $(this);
    $trophy.addClass('vibrate');
    setTimeout(function() {
        $trophy.removeClass('vibrate');
    }, 300);
  });

  function formatTime(timestamp) {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
  function formatDuration(durationString) {
    const durationMinutes = parseInt(durationString, 10);
    return durationMinutes;
  }
  window.addEventListener('message', async (event) => {
    if (event.origin === 'https://tally.so') {
      try {
        if (!event.data.startsWith('{')) {
          return;
        }
        const eventData = JSON.parse(event.data);
        if (eventData.event === 'Tally.FormSubmitted') {
          var formData = eventData.payload;
          var filteredData = formData.fields.filter(field => 
            field.title === 'Votre email professionnel' ||
            field.title === 'Nom de votre entreprise'
          );
          var filteredDataObject = {};
          filteredData.forEach(field => {
            if (field.title === 'Votre email professionnel') {
              filteredDataObject.email = field.answer.value;
            } else if (field.title === 'Nom de votre entreprise') {
              filteredDataObject.company = field.answer.value;
            }
          });
          Cookies.set('formData', JSON.stringify(filteredDataObject), {
            path: '/',
            sameSite: 'Lax',
            secure: false,
            expires: 1
          });
          onAuthStateChanged(auth, (user) => {
            window.location.href = 'https://www.salesridge.co/demo/assessment.html';
          });
        }
      } catch (error) {
        console.error('Erreur lors de l\'analyse des données de l\'événement:', error);
      }
    }
    if (event.origin === 'https://meetings-eu1.hubspot.com') {
      try {
        const eventData = event.data;
        if (eventData.meetingBookSucceeded) {
          const meetingsPayload = eventData.meetingsPayload;
          const bookingResponse = meetingsPayload.bookingResponse;
          const eventDetails = bookingResponse.event;
          const companyId = Cookies.get('companyId');
          async function addAppointment() {
            try {
              const appointmentRef = await addDoc(collection(db, 'appointments'), {
                companyId: companyId,
                date: eventDetails.dateString,
                duration: formatDuration(eventDetails.duration),
                time: formatTime(eventDetails.dateTime)
              });
              $('<div class="notificationsRDV"><p>Rendez-vous pris avec succès.</p></div>').prependTo('body .plan');
              $('body').removeClass('bookMeeting');
            } catch (e) {
              console.error("Error adding document: ", e);
            }
          }
          await addAppointment();
        }
      } catch (error) {
        console.error('Erreur lors de la conversion du message en JSON:', error);
      }
    }
  });
  $(document).on("click", "#startAssessment", function() {
    $('body').addClass('startAssessment');
  });
  //MOBILE
  $('#mobileMenu').on('click', function() {
    event.preventDefault();
    $('body').addClass('navOpen');
  });
  $('#navBackground').on('click', function() {
    event.preventDefault();
    $('body').removeClass('navOpen');
  });
  //HUBSPOT - Chargement sécurisé avec gestion d'erreur
  function loadHubSpotScript() {
    return new Promise((resolve, reject) => {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'hs-script-loader';
      script.async = true;
      script.defer = true;
      script.src = '//js.hs-scripts.com/26298630.js';
      
      script.onload = function() {
        console.log('✅ HubSpot script chargé avec succès');
        resolve();
      };
      
      script.onerror = function() {
        console.warn('⚠️ HubSpot script bloqué par le navigateur (bloqueur de pub)');
        // Ne pas faire échouer l'application si HubSpot est bloqué
        resolve();
      };
      
      $('body').append(script);
    });
  }
  
  // Charger HubSpot de manière non-bloquante
  loadHubSpotScript().catch(error => {
    console.warn('HubSpot non disponible:', error);
  });
  //TABS
  $('.tab-links a').on('click', function(e) {
    e.preventDefault();
    var tabId = $(this).attr('href');
    $('.tab-links li, .tab').removeClass('active');
    $(this).parent('li').addClass('active');
    $(tabId).addClass('active');
  });
  $(document).on('click', '.tab-links2 a', async function(e) {
    e.preventDefault();
    var tabId = $(this).attr('href');
    $('.tab-links2 li, .tab2').removeClass('active');
    $(this).parent('li').addClass('active');
    $(tabId).addClass('active');
  });
  //STATUSSEQUENCESMODAL
  $(".statusSequencesModal input").on("keyup", function() {
    let searchText = $(this).val().toLowerCase();
    $(".statusSequencesModal p").each(function() {
        let text = $(this).text().toLowerCase();
        if (text.includes(searchText)) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
  });
  $(document).on("click", function(event) {
    if (!$(event.target).closest(".statusSequencesModal, .statusSequences").length) {
      $(".statusSequencesModal").removeClass("active");
      $(".statusSequencesModal input").val('');
      $(".statusSequencesModal p").each(function() {
        $(this).show();
      });
    }
  });
  $(document).on('click', '.statusSequences', async function(event) {
    $(".statusSequencesModal input").val('');
    $(".statusSequencesModal p").each(function() {
      $(this).show();
    });
    let modal = $(".statusSequencesModal");
    let windowHeight = $(window).height();
    let windowWidth = $(window).width();
    let modalHeight = modal.outerHeight();
    let modalWidth = modal.outerWidth();
    let clickX = event.pageX;
    let clickY = event.pageY;

    let posX = clickX;
    let posY = clickY;

    // GESTION DU POSITIONNEMENT VERTICAL
    if (clickY + modalHeight > windowHeight - 20) { 
        posY = clickY - modalHeight - 10;
    } else { 
        posY = clickY + 10;
    }

    // GESTION DU POSITIONNEMENT HORIZONTAL
    if (clickX + modalWidth > windowWidth - 20) { 
        posX = clickX - modalWidth - 10;
    } else { 
        posX = clickX + 10;
    }

    // Associer la modal au bon élément cliqué
    modal.data("target", $(this));

    modal.css({
        "top": posY + "px",
        "left": posX + "px",
    }).addClass("active");
  });
  

  $(document).on("click", ".statusSequencesModal p", async function () {
    let newStatusText = $(this).text().trim(); 
    let newStatus = $(this).attr('data-value'); 
    let target = $(".statusSequencesModal").data("target");

    if (!target) {
        console.error("❌ Erreur : aucun élément statusSequences associé à la modal.");
        return;
    }

    let leadId = target.data("lead");
    let campaignId = target.data("campaign");
    let stepIndex = target.data("step");

    if (!leadId || !campaignId || stepIndex === undefined) {
        console.error("❌ Erreur : Données manquantes (leadId, campaignId ou stepIndex)");
        return;
    }

    target.text(newStatusText).removeClass().addClass(`statusSequences ${newStatusText}`);

    const leadRef = doc(db, "leads", leadId);
    getDoc(leadRef)
        .then((leadSnap) => {
            if (leadSnap.exists()) {
                let leadData = leadSnap.data();
                
                if (leadData.campaigns && leadData.campaigns[campaignId] && Array.isArray(leadData.campaigns[campaignId].steps)) {
                    let steps = leadData.campaigns[campaignId].steps;

                    if (steps[stepIndex]) {
                        steps[stepIndex].status = newStatus;
                        updateDoc(leadRef, {
                            [`campaigns.${campaignId}.steps`]: steps
                        }, { merge: true })
                        .then(() => {
                            console.log(`✅ Statut mis à jour : ${newStatus}`);
                        })
                        .catch((error) => {
                            console.error("❌ Erreur de mise à jour Firestore :", error);
                        });
                    } else {
                        console.error("❌ Erreur : Step index non trouvé.");
                    }
                } else {
                    console.error("❌ Erreur : Campagne ou steps non trouvés.");
                }
            }
        })
        .catch((error) => {
            console.error("❌ Erreur de récupération du lead :", error);
        });

    // Fermer la modal après mise à jour
    $(".statusSequencesModal").removeClass("active");
  });
});


//NOTIFICATIONS
/**
// Système de notifications Firestore en temps réel
function initNotificationsSystem() {
  console.log('🚀 Initialisation du système de notifications...');
  // Vérifier si l'utilisateur est connecté
  // Gestionnaire d'auth avec protection contre les multiples déclenchements
  let authHandlerActive = false;
  
  const authUnsubscribe = onAuthStateChanged(auth, async (user) => {
    if (authHandlerActive) {
      console.log('⚠️ [Auth] Évite le double déclenchement du handler');
      return;
    }
    
    authHandlerActive = true;
    
    if (user) {
      console.log('👤 Utilisateur connecté:', user.email);
      // Récupérer l'ID de l'entreprise de l'utilisateur
      var companyId = Cookies.get('companyId');
      const userAdmin = Cookies.get('admin');
      if (!userAdmin) {
        if (!companyId) {
          console.error('❌ Aucun ID d\'entreprise trouvé, notifications désactivées');
          return;
        }
        listenForNotifications(companyId);
        console.log('🏢 ID de l\'entreprise:', companyId);
      }
      else{
        companyId = 'admin';
        listenForNotifications(companyId);
      }
    } else {
      console.log('❌ Aucun utilisateur connecté, notifications désactivées');
    }
  });
}
function listenForNotifications(companyId) {
  // Éviter les listeners multiples pour le même companyId
  if (window.__SR__notificationsActiveForCompany === companyId) {
    console.log('⚠️ [Notifications] Déjà actif pour cette entreprise:', companyId);
    return;
  }
  
  // Nettoyer l'ancien listener s'il existe
  if (window.__SR__notificationsUnsubscribe) {
    console.log('🧹 [Notifications] Nettoyage de l\'ancien listener');
    window.__SR__notificationsUnsubscribe();
    window.__SR__notificationsUnsubscribe = null;
  }
  
  window.__SR__notificationsActiveForCompany = companyId;
  console.log('👂 Démarrage de l\'écoute des notifications pour la compagnie:', companyId);
  
  // Créer une requête pour récupérer les notifications de l'entreprise
  let notificationsQuery;
  
  if (companyId === 'admin') {
    notificationsQuery = query(
      collection(db, 'notifications'),
      where('adminMode', '==', true),
      orderBy('timestamp', 'desc')
    );
  }
  else{
    notificationsQuery = query(
      collection(db, 'notifications'),
      where('companyId', '==', companyId),
      orderBy('timestamp', 'desc')
    );
  }
  let processedToasts = new Set();
  
  // Écouter les changements en temps réel et stocker l'unsubscribe
  window.__SR__notificationsUnsubscribe = onSnapshot(notificationsQuery, (snapshot) => {
    console.log(`📊 ${snapshot.size} notifications trouvées dans Firestore`);
    
    const $notificationsContainer = $('#notificationsContainer');
    if ($notificationsContainer.length === 0) {
      console.error('❌ Container de notifications non trouvé dans le DOM');
      return;
    }
    
    // Vider le conteneur de notifications
    $notificationsContainer.empty();
    
    let unreadCount = 0;
    
    // Parcourir toutes les notifications
    snapshot.forEach((doc) => {
      const notification = doc.data();
      const notifId = doc.id;
      
      console.log(`📝 Notification trouvée: ${notifId}`, notification);
      
      // Compter les notifications non lues
      if (!notification.read) {
        unreadCount++;
      }
      
      // Ajouter la notification au conteneur
      const $notificationElement = createNotificationElement(notifId, notification);
      $notificationsContainer.append($notificationElement);
      
      // Si c'est une nouvelle notification non lue, afficher un toast standalone
      if (!notification.read && !processedToasts.has(notifId)) {
        processedToasts.add(notifId);
        showStandaloneToast({ id: notifId, ...notification });
      }
    });
    
    console.log(`🔔 ${unreadCount} notifications non lues`);
    
    // Mettre à jour le compteur de notifications
    updateNotificationCounter(unreadCount);
  }, (error) => {
    console.error('❌ Erreur lors de l\'écoute des notifications:', error);
  });
}
function updateNotificationCounter(count) {
  const $counter = $('#notificationCounter');
  
  if (count > 0) {
    if ($counter.length === 0) {
      // Créer le compteur s'il n'existe pas
      $('#navAccount').prepend(`<div id="notificationCounter">${count}</div>`);
    } else {
      // Mettre à jour le compteur existant
      $counter.text(count).show();
    }
  } else {
    // Cacher le compteur s'il n'y a pas de notifications
    if ($counter.length > 0) {
      $counter.hide();
    }
  }
}
function createNotificationElement(notifId, notification) {
  const timestamp = new Date(notification.timestamp);
  const formattedTime = formatNotificationTime(timestamp);
  const isRead = notification.read;
  const statusClass = notification.status || 'info';
  
  return $(`
    <div class="toast-notification ${statusClass} ${isRead ? 'read' : ''}" data-id="${notifId}" data-campaign-id="${notification.campaignId || ''}">
      <div class="toast-header">
        <strong>${getNotificationTitle(notification)}</strong>
        <div class="notification-actions">
          <button class="toast-delete">🗑️</button>
          <button class="toast-close">×</button>
        </div>
      </div>
      <div class="toast-body">
        <p>${notification.message}</p>
        <small>${formattedTime}</small>
      </div>
    </div>
  `);
}
function getNotificationTitle(notification) {
  const typeMap = {
    'campaign_update': 'Mise à jour de campagne',
    'smartlead_sent': 'Leads envoyés à SmartLead',
    'smartlead_error': 'Erreur SmartLead',
    'blacklist_blocked': 'Blacklist active',
    'process_error': 'Erreur de traitement'
  };
  
  return typeMap[notification.type] || 'Notification';
}
function formatNotificationTime(timestamp) {
  const now = new Date();
  const diff = Math.floor((now - timestamp) / 1000); // Différence en secondes
  
  if (diff < 60) {
    return 'À l\'instant';
  } else if (diff < 3600) {
    const minutes = Math.floor(diff / 60);
    return `Il y a ${minutes} min${minutes > 1 ? 's' : ''}`;
  } else if (diff < 86400) {
    const hours = Math.floor(diff / 3600);
    return `Il y a ${hours} h${hours > 1 ? 's' : ''}`;
  } else {
    const days = Math.floor(diff / 86400);
    return `Il y a ${days} jour${days > 1 ? 's' : ''}`;
  }
}
async function markNotificationAsRead(notificationId) {
  try {
    console.log(`📖 Marquage de la notification ${notificationId} comme lue`);
    const notificationRef = doc(db, 'notifications', notificationId);
    await updateDoc(notificationRef, { read: true });
    console.log(`✅ Notification ${notificationId} marquée comme lue`);
    
    // Ajouter la classe read à l'élément correspondant
    $(`.toast-notification[data-id="${notificationId}"]`).addClass('read');
  } catch (error) {
    console.error('❌ Erreur lors du marquage de la notification comme lue:', error);
  }
}
async function deleteNotification(notificationId) {
  try {
    // Demander confirmation à l'utilisateur avant de supprimer
    if (confirm('Êtes-vous sûr de vouloir supprimer cette notification ?')) {
      console.log(`🗑️ Suppression de la notification ${notificationId}`);
      
      // Référence au document de notification
      const notificationRef = doc(db, 'notifications', notificationId);
      
      // Optimisation: utiliser un batch pour combiner les opérations et réduire les écritures
      const batch = writeBatch(db);
      batch.update(notificationRef, { 
        read: true,
        deleted: true,
        deletedAt: new Date().toISOString() // Ajout d'un timestamp de suppression pour traçabilité
      });
      
      // Exécuter le batch
      await batch.commit();
      console.log(`✅ Notification ${notificationId} supprimée`);
      
      // Animation de suppression de l'élément du DOM
      $(`.toast-notification[data-id="${notificationId}"]`).fadeOut(300, function() {
        $(this).remove();
        
        // Mettre à jour le compteur de notifications après suppression
        const unreadCount = $('#notificationsContainer .toast-notification:not(.read)').length;
        updateNotificationCounter(unreadCount);
      });
    }
  } catch (error) {
    console.error('❌ Erreur lors de la suppression de la notification:', error);
    alert('Une erreur est survenue lors de la suppression de la notification.');
  }
}
// Fonction pour afficher un toast de notification standalone
function showStandaloneToast(notification) {
  console.log('🔔 Affichage du toast standalone pour la notification:', notification);
  
  // Supprimer les anciens toasts si nécessaire
  if ($('.toast-notification.standalone').length > 2) {
    $('.toast-notification.standalone').first().remove();
  }
  
  // Formater la date pour l'affichage
  const timestamp = new Date(notification.timestamp);
  const formattedTime = formatNotificationTime(timestamp);
  
  // Créer le toast
  const statusClass = notification.status || 'info';
  const toast = $(`
    <div class="toast-notification standalone ${statusClass}" data-id="${notification.id}" data-campaign-id="${notification.campaignId || ''}">
      <div class="toast-header">
        <strong>${getNotificationTitle(notification)}</strong>
        <button class="toast-close">×</button>
      </div>
      <div class="toast-body">
        <p>${notification.message}</p>
        <small>${formattedTime}</small>
      </div>
    </div>
  `);
  
  // Ajouter au body et afficher
  $('body').append(toast);
  setTimeout(() => {
    toast.addClass('show');
  }, 10);
  
  // Fermeture au clic
  toast.find('.toast-close').on('click', function() {
    toast.removeClass('show');
    setTimeout(() => {
      toast.remove();
    }, 300);
  });
  
  // Auto-fermeture après 8 secondes
  setTimeout(() => {
    if (toast.length) {
      toast.removeClass('show');
      setTimeout(() => {
        toast.remove();
      }, 300);
    }
  }, 8000);
  
  // Marquer comme lu et rediriger au clic sur le toast
  toast.on('click', function(e) {
    if (!$(e.target).hasClass('toast-close')) {
      markNotificationAsRead(notification.id);
      if (notification.campaignId) {
        window.location.href = `/campaign.html?id=${notification.campaignId}`;
      } else {
        toast.removeClass('show');
        setTimeout(() => {
          toast.remove();
        }, 300);
      }
    }
  });
}
// Déléguer les événements pour les notifications
$(document).on('click', '.toast-notification:not(.standalone)', function(e) {
  if (!$(e.target).hasClass('toast-close') && !$(e.target).hasClass('toast-delete')) {
    const notifId = $(this).data('id');
    console.log(`🖱️ Clic sur la notification ${notifId}`);
    markNotificationAsRead(notifId);
    
    const campaignId = $(this).data('campaign-id');
    if (campaignId) {
      window.location.href = `/campaign.html?id=${campaignId}`;
    }
  }
});
$(document).on('click', '.toast-close', function(e) {
  e.stopPropagation();
  const $notification = $(this).closest('.toast-notification');
  const notifId = $notification.data('id');
  console.log(`🖱️ Clic sur fermer pour la notification ${notifId}`);
  markNotificationAsRead(notifId);
  
  if ($notification.hasClass('standalone')) {
    $notification.removeClass('show');
    setTimeout(() => {
      $notification.remove();
    }, 300);
  }
});
$(document).on('click', '.toast-delete', function(e) {
  e.stopPropagation();
  const $notification = $(this).closest('.toast-notification');
  const notifId = $notification.data('id');
  console.log(`🖱️ Clic sur supprimer pour la notification ${notifId}`);
  deleteNotification(notifId);
});
**/

// Ajout d'un gestionnaire pour afficher le modal des notifications
$(document).on('click', '#notificationCounter, #dots', function(e) {
  e.stopPropagation();
  console.log('🖱️ Clic sur le compteur de notifications ou les points');
  $('#modalAccount').toggleClass('active');
});
// Cacher le modal quand on clique ailleurs
$(document).on('click', function(e) {
  if (!$(e.target).closest('#modalAccount, #notificationCounter, #dots').length) {
    $('#modalAccount').removeClass('active');
  }
});